/* global $:false */

export default class LotIndex {
  static init () {
    if (this.instance) { return }
    this.instance = new LotIndex()
  }

  constructor () {
    this._addEffectForUpdatedResult()
  }

  _addEffectForUpdatedResult () {
    $(document).on('htmlPush:afterReplace', '.js-lot-index-lot', e => {
      const originalResult = $(e.detail.originalContent).find('.js-market-lot-index-lot__result')
      const newResult = $(e.detail.elt).find('.js-market-lot-index-lot__result')
      if (originalResult[0].innerHTML === newResult[0].innerHTML) { return }

      newResult.addClass('u-effects-highlight')
    })
  }
}
